import { useState } from "react";
import { Badge } from "react-bootstrap";
import { useSelector } from "react-redux";
import NotificationService from "../../../../services/NotificationService";
import DeleteModal from "../../../common/DeleteModal";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const notificationService = new NotificationService();

	return (
		<>
			<tr key={index} className="text-center">
				<td>{lang === "ar" ? item.massageTitleAr : item.massageTitleEn}</td>
				<td>{lang === "ar" ? item.massageBodyAr : item.massageBodyEn}</td>
				<td>
					<Badge variant="primary" style={{ textTransform: "capitalize" }}>
						{item.type || "-"}
					</Badge>
				</td>
				<td>{item.createdAt?.split("T")[0] || "-"}</td>
				<td>
					<i
						className="la la-trash text-danger cursor-pointer"
						style={{ fontSize: "1.4rem" }}
						onClick={() => setDeleteModal(true)}
					/>
				</td>
			</tr>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={lang === "ar" ? item.massageTitleAr : item.massageTitleEn}
					deletedItem={item}
					modelService={notificationService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</>
	);
};

export default CardItem;
